

































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { FiservDebitCardInfo, BootstrapVueRowDetails } from "@/shared/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFiservDebitCardsStore } from "@/shared/store/fiservDebitCards";

@Component({
  components: {
  }
})
export default class FiservDebitCardConfirmReplacementForm extends Vue {

  notifierStore = useNotifierStore();
  fiserveDebitCardsStore = useFiservDebitCardsStore();

  @Prop()
  row: BootstrapVueRowDetails;

  @Prop()
  card: FiservDebitCardInfo;

  onSubmitChanges (e: Event) {
    e.preventDefault();

    this.fiserveDebitCardsStore.confirmReplacementFiservDebitCard(this.card.fiservUserInfoId)
      .then(() => {
        this.notifierStore.setSuccess(`Confirmed replacement for card with last four digits "${this.card.cardNumberLast4}".`);
        this.row.toggleDetails();
      }).catch(() => {
        this.notifierStore.setDanger(`There was an error confirming your replacement card. Please wait and try again later.`);
      });
  }

}
